// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2iIum","errorLogs":"styles_errorLogs__auNf6"};